import styled, { css } from 'styled-components'
import { ThemeColorsKeysType } from 'src/components/Core/Styles/theme'
import { FontProps } from './types'

export const FontStyle = styled('p') <FontProps>`
  font-family: ${props => props.theme.font?.family[props.isMiller ? 1 : 0]};
  font-size: ${props => props.smallest && props.theme?.font?.size?.smallest ? props.theme?.font?.size?.smallest :
    (props.tag ? props.theme?.font?.size?.[props.tag] : '14px')};
  font-weight: ${props => (props.bold ? 'bold' : 'initial')};
  white-space: ${props =>
    props.tag === 'p' || typeof props.tag === 'undefined'
      ? 'pre-wrap'
      : 'normal'};
  margin: ${props => props.margin || '0'};
  color: ${props =>
    props.theme.colors?.main?.[props.color as ThemeColorsKeysType]};
  ${props =>
    props.onClick &&
    css`
       cursor: pointer;
  `}
  ${props =>
    props.oneLine &&
    css`
      white-space: nowrap;
    `}
  ${props =>
    props.ellipsis &&
    css`
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      max-width: 100%;
    `}
  ${props =>
    props.multiLineEllipsis > 0 &&
    css`
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: normal;
      max-width: 100%;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: ${props.multiLineEllipsis};
    `}
  ${props =>
    props.gridArea &&
    css`
      grid-area: ${props.gridArea};
    `}
  ${props =>
    props.tooltipLabel &&
    css`
      display: flex;
    `}
  ${props =>
    props.display &&
    css`
      display: flex;
    `}
  ${props =>
    props.lineHeight &&
    css`
      line-height: ${props.lineHeight};
    `}
  ${props =>
    props.width &&
    css`
      width: ${props.width};
    `}
  ${props =>
    props.toUpperCase &&
    css`
      text-transform: uppercase;
    `}
  ${props =>
    props.textAlign &&
    css`
      text-align: ${props.textAlign};
    `}
  ${props => props.bgColor && css`
    background-color: ${props.bgColor};
  `}

  ${props => props.border && css`
    border: ${props.border};
    border-radius: 4px;
  `}
  
  ${props => props.padding && css`
    padding: ${props.padding};
  `}

  ${props => props.minHeight && css`
    min-height: ${props.minHeight};
  `}

    ${props => props.whiteSpace && css`
    white-space: ${props.whiteSpace};
  `}
`
